import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import MenuTypeListPage from 'src/pages/dashboard/menustype/list';
import DishCategoryListPage from 'src/pages/dashboard/dishcategory/list';
import EmentasListPage from 'src/pages/dashboard/ementas/list';
import EmentasCreatePage from 'src/pages/dashboard/ementas/new';
import DishListPage from 'src/pages/dashboard/dish/list';
import EmentasEditPage from 'src/pages/dashboard/ementas/edit';
import GaleryListPage from 'src/pages/dashboard/galery/list';
import CarouselListPage from 'src/pages/dashboard/carousel/list';
import UserListPage from 'src/pages/dashboard/users/list';
import ReservationListPage from 'src/pages/dashboard/reservations/list';
import AllergenListPage from 'src/pages/dashboard/allergen/list';
import BusinessHoursListPage from 'src/pages/dashboard/business-hours/list';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/app'));


// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'param/menutype', element: <MenuTypeListPage />},
      { path: 'param/dishcategory', element: <DishCategoryListPage />},
      {path: 'param/dish', element: <DishListPage />},
      { path: 'ementas/list', element: <EmentasListPage /> },
      { path: 'ementas/create', element:  <EmentasCreatePage />},
      { path: 'ementas/edit/:id', element:  <EmentasEditPage />},
      { path: 'galery', element:  <GaleryListPage />},
      { path: 'carousel', element: <CarouselListPage />},
      { path: 'users', element: <UserListPage />},
      { path: 'reservas', element: <ReservationListPage />},
      { path: 'param/allergen', element: <AllergenListPage />},
      { path: 'horarios', element: <BusinessHoursListPage />}
    ],
  },
];
